import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, MapPin, Clock } from "lucide-react";

const events = [
  {
    title: "Annual Sports Day",
    date: "January 15, 2025",
    time: "9:00 AM",
    location: "School Sports Ground",
    description: "A day of athletic competitions and team sports for all grades.",
    image: "https://images.unsplash.com/photo-1461896836934-eba09b295a37?auto=format&fit=crop&w=600&q=80",
    type: "Sports",
  },
  {
    title: "Science Exhibition",
    date: "January 25, 2025",
    time: "10:00 AM",
    location: "School Auditorium",
    description: "Students showcase innovative science projects and experiments.",
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=600&q=80",
    type: "Academic",
  },
  {
    title: "Republic Day Celebration",
    date: "January 26, 2025",
    time: "8:00 AM",
    location: "School Ground",
    description: "Flag hoisting and cultural program to celebrate Republic Day.",
    image: "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?auto=format&fit=crop&w=600&q=80",
    type: "Cultural",
  },
];

export const EventsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-secondary font-medium text-sm uppercase tracking-wider">
            Events & News
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">
            Upcoming Events
          </h2>
          <div className="section-divider mx-auto"></div>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Stay updated with the latest happenings and upcoming events at ID4U School.
          </p>
        </motion.div>

        {/* Events Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {events.map((event, index) => (
            <motion.div
              key={event.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 hover:shadow-xl transition-all duration-300 group"
              data-testid={`event-${index}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-secondary text-white text-xs font-medium px-3 py-1 rounded-full">
                  {event.type}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3">
                  {event.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">{event.description}</p>
                <div className="space-y-2 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <Calendar size={16} className="text-primary" />
                    <span>{event.date}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock size={16} className="text-primary" />
                    <span>{event.time}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin size={16} className="text-primary" />
                    <span>{event.location}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center"
        >
          <Link to="/events">
            <Button className="bg-primary hover:bg-primary/90 rounded-full px-8">
              View All Events
              <ArrowRight size={18} className="ml-2" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
